import { render, staticRenderFns } from "./BrowseGoalsWizard.vue?vue&type=template&id=ba690220&scoped=true"
import script from "./BrowseGoalsWizard.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsWizard.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsWizard.vue?vue&type=style&index=0&id=ba690220&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba690220",
  null
  
)

export default component.exports